<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <NavBar />
    
    <transition name="fade">
      <router-view/>
    </transition>

    <Foot/>    
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Foot from '@/components/Foot.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    Foot
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

/* ____________________________________ */

// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #398CCB;
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);
$secondary: #398CCB;
$secondary-invert: findColorInvert($secondary);
$success: #015172;
$success-invert: findColorInvert($success);
$light: #EFF6FC;
$light-invert: findColorInvert($light);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert),
    "secondary": ($secondary, $secondary-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

</style>
